import * as React from 'react'

const SvgEmailIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 3.75h-15c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM16.125 5L10 9.238 3.875 5h12.25zM2.5 15V5.569l7.144 4.943a.625.625 0 00.712 0L17.5 5.57V15h-15z"
      fill="#163250"
    />
  </svg>
)

export default SvgEmailIcon
